export default `
varying vec3 vNormal;
varying vec3 vViewPosition;
varying vec3 vPosition;
varying vec3 vWorldPos;

varying vec2 vUv;


void main(){
  vNormal = normalize(normalMatrix * normal);

  vec4 worldPosition;
  vec4 viewPosition;

  worldPosition = modelMatrix * vec4(position, 1.0);
  vWorldPos = worldPosition.xyz;
  viewPosition = viewMatrix * worldPosition;
  vPosition = worldPosition.xyz / modelMatrix[3][3];

  vViewPosition = viewPosition.xyz;
  vUv = uv;

  gl_Position = projectionMatrix * viewPosition;
}
`
